import React from 'react';
import { Notifier } from '@airbrake/browser';
import { airbrakeProductId, airbrakeProductKey } from 'core/config/env';

type Props = {
  children: any
};

class AirBrakeNotifier extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.airbrake = new Notifier({
      projectId: airbrakeProductId || 1,
      projectKey: airbrakeProductKey || 'none'
    });
  }

  componentDidCatch(error, info) {
    this.airbrake.notify({
      error,
      params: { info }
    });
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

export default AirBrakeNotifier;
